import { computed, ref } from 'vue';

export function useStepper(steps) {
    // TODO: refactor this further, to make the composable more generic
    const visibleSteps = steps.filter(step => !step.hideFromStepper);
    const allSteps = steps;

    const currentIndex = ref(0);
    const currentStep = computed(() => allSteps[currentIndex.value]);

    function goTo(index) {
        if (index >= 0 && index < allSteps.length) {
            currentIndex.value = index;
        }
    }

    function goToNext() {
        if (currentIndex.value < allSteps.length - 1) {
            currentIndex.value++;
        }
    }

    function goToPrevious() {
        if (currentIndex.value > 0) {
            currentIndex.value--;
        }
    }

    function goToStep(key) {
        const index = allSteps.findIndex(step => step.key === key);
        if (index !== -1) {
            currentIndex.value = index;
        }
    }

    const isFirst = computed(() => currentIndex.value === 0);
    const isLastActionableStep = computed(() => {
        const lastActionableStep = visibleSteps[visibleSteps.length - 1];
        return currentStep.value.key === lastActionableStep.key;
    });

    function isCurrent(index) {
        return currentIndex.value === index;
    }

    function allBeforeAreValid(index) {
        return visibleSteps.slice(0, index).every(step => step.isValid?.());
    }

    const isThankYouPage = computed(() => currentStep.value.key === 'thank-you');

    /**
     * If valid, this will be able to proceed to next step or be able to submit.
     */
    const isValidCurrentStep = computed(() => currentStep.value.isValid());

    return {
        steps: visibleSteps,    // header rendering
        currentStep,
        currentIndex,
        goTo,
        goToNext,
        goToPrevious,
        goToStep,
        isCurrent,
        isFirst,
        isLastActionableStep,
        allBeforeAreValid,
        isThankYouPage,
        isValidCurrentStep,
    };
}
